import React, {Component} from "react";
import {Link} from "react-router-dom";
import Base64 from "base-64";
import Cookies from "universal-cookie";
import UserDropDown from "../UserDropDown";
import Gnb from "../Gnb";

class Header extends Component {

    state = {
        decodedCookie: {},
        isUpdate: false,
        signin: ''
    }

    constructor(props) {
        super(props);
        this.decodeCookie();
    }

    // token decode
    decodeCookie = () => {
        const cookies = new Cookies();
        if (cookies.get('beacon_token') == null || (cookies.get('beacon_token') != null && cookies.get('beacon_token').isEmpty)) {
            return;
        }
        // cookie 값에서 signature 뺌
        const beaconToken = cookies.get('beacon_token').split('.')[1];
        // decode cookie
        const decodedCookie = JSON.parse(Base64.decode(beaconToken));
        this.state.decodedCookie = decodedCookie;
    }

    /** login page  일 경우 header 변경 */
    loginPage = () => {
        return (
            <header className="headerWrapper">
                <div className="gatewayWrapper">
                    <div className="gatewayInner">
                        <h1>
                            <Link to="/app/login">
                                <img src="/images/common/logo_header.png" alt="Beacon Education"/>
                            </Link>
                        </h1>
                        <span className="secondlogo">
                            <img src="/images/common/logo_echo.png" alt="Echo online"/>
                        </span>
                    </div>
                </div>
            </header>
        );
    }


    render() {
        // root page or login page
        if (document.location.pathname === '/' || document.location.pathname === '/app/login') {
            return this.loginPage();
        }

        const LogoClickLink = () => {
            const {decodedCookie} = this.state;
            const identity = decodedCookie['jti'];

            if (identity != null && !identity.isEmpty && identity !== 'undefined' && identity === 'I_STUDENT') {
                return (
                    <Link to="/app/homework">
                        <img src="/images/common/logo_header.png" alt="Beacon Education"/>
                    </Link>
                );
            } else if (identity != null && !identity.isEmpty && identity !== 'undefined'
                && (identity === 'I_TEACHER' || identity === 'I_ADMIN' || identity === 'I_BEACON')) {
                return (
                    <Link to="/app/teacher">
                        <img src="/images/common/logo_header.png" alt="Beacon Education"/>
                    </Link>
                );
            } else if (identity != null && !identity.isEmpty && identity !== 'undefined' && identity === 'I_ATTENDANCE') {
                return (
                    <Link to="/app/attendance">
                        <img src="/images/common/logo_header.png" alt="Beacon Education"/>
                    </Link>
                );
            } else {
                return (
                    <Link to="/app/login">
                        <img src="/images/common/logo_header.png" alt="Beacon Education"/>
                    </Link>
                );
            }
            ;

            return (
                <Link to="/app/login">
                    <img src="/images/common/logo_header.png" alt="Beacon Education"/>
                </Link>
            );
        }

        return (
            <header className="headerWrapper">
                <div className="gatewayWrapper">
                    <div className="gatewayInner">
                        <h1>
                            <LogoClickLink/>
                        </h1>
                        <h6>{this.state.signin}</h6>
                        <UserDropDown isUpdate={this.props.isUpdate}/>
                    </div>
                </div>
                <Gnb selectedIndex={this.props.selectedIndex} decodedCookie={this.state.decodedCookie}/>
            </header>
        );
    }
}

Header.defaultProps = {
    isUpdate: false,
}
export default Header;


// WEBPACK FOOTER //
// ./src/components/Containers/Header/Header/index.js